import React from 'react';
import './Screenshots.css';
import autoloadoutsImgSrc from '../assets/autoloadouts.png';
import braveryImgSrc from '../assets/bravery.png';
import summonerProfileImgSrc from '../assets/summoner_profile.png';
import themesImgSrc from '../assets/themes.png';
import viewLoadoutsImgSrc from '../assets/view_loadouts.png';
import ingameImgSrc from '../assets/ingame.png';

const Screenshots: React.FC = () => {
  return (
    <section className="screenshots" id="screenshots">
      <div className="container">
        <h2>Screenshots</h2>
        <p>Take a look at selected LeagueTools pages</p>
        <div className="screenshots-grid">
          <div className="screenshot-item">
            <img src={ingameImgSrc} alt="Ingame" />
            <div className="screenshot-overlay">
              <p>Ingame</p>
            </div>
          </div>
          <div className="screenshot-item">
            <img src={viewLoadoutsImgSrc} alt="Loadouts" />
            <div className="screenshot-overlay">
              <p>Loadouts</p>
            </div>
          </div>
          <div className="screenshot-item">
            <img src={autoloadoutsImgSrc} alt="AutoLoadouts" />
            <div className="screenshot-overlay">
              <p>AutoLoadouts</p>
            </div>
          </div>
          <div className="screenshot-item">
            <img src={summonerProfileImgSrc} alt="Summoner Profiles" />
            <div className="screenshot-overlay">
              <p>Summoner Profiles</p>
            </div>
          </div>
          <div className="screenshot-item">
            <img src={braveryImgSrc} alt="Ultimate Bravery" />
            <div className="screenshot-overlay">
              <p>Ultimate Bravery</p>
            </div>
          </div>
          <div className="screenshot-item">
            <img src={themesImgSrc} alt="Themes" />
            <div className="screenshot-overlay">
              <p>Themes</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Screenshots; 